module.exports = __webpack_public_path__ + "img/MGH-Gion-11-2440x1172.a0508ced.jpg";